import { BASE } from '../enum';

export const bases = {
	[`${BASE.AWAKENING}`]: {
		id: 656,
		name: 'Awakening Potion',
		comment: '',
	},
	[`${BASE.BERSERK}`]: {
		id: 657,
		name: 'Berserk Potion',
		comment: '',
	},
	[`${BASE.CONCENTRATION}`]: {
		id: 645,
		name: 'Concentration Potion',
		comment: '',
	},
};
